/* eslint-disable @typescript-eslint/naming-convention */
import { DOWNSTREAM_HOSTS } from "@cart-client/constants/Hosts";
import { makeDownstreamApiCall, unwrapResponseWithCode } from "@cart-client/utils/Api";
import {
    GetGroupCartOrderResponse,
    IUpdateGroupCartOrderRequestPayload,
    UpdateGroupCartOrderResponse,
    LockGroupCartOrderResponse,
    NativeLocalCart,
} from "@swiggy-private/cart-types";
import { HTTP_METHODS } from "@swiggy-private/checkout-core";

const ENDPOINT = {
    GET_SHARED_CART: "/api/v1/shared_cart",
    UPDATE_SHARED_CART: "/api/v1/shared_cart/update",
    GROUP_CART_LOCK_API: "/api/v1/shared_cart/lock",
    GROUP_CART_UNLOCK_API: "/api/v1/shared_cart/unlock",
};

export async function getGroupCartOrderItems(groupCartId: string): Promise<GetGroupCartOrderResponse> {
    const response = await makeDownstreamApiCall<GetGroupCartOrderResponse>({
        apiHost: DOWNSTREAM_HOSTS.CHECKOUT_READ_HOST,
        endpoint: ENDPOINT.GET_SHARED_CART,
        options: {
            method: HTTP_METHODS.GET,
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        searchParams: { group_cart_id: groupCartId },
    });

    return response;
}

export async function updateGroupCartOrderItemsCall(
    requestPayload: IUpdateGroupCartOrderRequestPayload,
): Promise<GetGroupCartOrderResponse> {
    const response = await makeDownstreamApiCall<UpdateGroupCartOrderResponse>({
        apiHost: DOWNSTREAM_HOSTS.CHECKOUT_READ_HOST,
        endpoint: ENDPOINT.UPDATE_SHARED_CART,
        options: {
            method: HTTP_METHODS.POST,
            body: JSON.stringify(requestPayload),
        },
    });

    return response;
}

export async function groupCartLockApi(
    groupCartId: string,
    hostUserId: string,
): Promise<LockGroupCartOrderResponse["data"]> {
    const response = unwrapResponseWithCode(
        await makeDownstreamApiCall<LockGroupCartOrderResponse>({
            apiHost: DOWNSTREAM_HOSTS.CHECKOUT_READ_HOST,
            endpoint: ENDPOINT.GROUP_CART_LOCK_API,
            options: {
                method: HTTP_METHODS.POST,
                body: JSON.stringify({
                    group_cart_id: groupCartId,
                    host_user_id: hostUserId,
                }),
            },
        }),
    );

    return response.toPromise();
}

export async function groupCartUnlockApi(
    groupCartId: string,
    hostUserId: string,
    mergedCartPayload: NativeLocalCart,
): Promise<GetGroupCartOrderResponse["data"]> {
    const response = unwrapResponseWithCode(
        await makeDownstreamApiCall<GetGroupCartOrderResponse>({
            apiHost: DOWNSTREAM_HOSTS.CHECKOUT_READ_HOST,
            endpoint: ENDPOINT.GROUP_CART_UNLOCK_API,
            options: {
                method: HTTP_METHODS.POST,
                body: JSON.stringify({
                    group_cart_id: groupCartId,
                    host_user_id: hostUserId,
                    merged_cart_payload: mergedCartPayload,
                }),
            },
        }),
    );

    return response.toPromise();
}
